var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "heicConversionView" },
    [
      _c("div", { staticClass: "mainHeader" }, [
        _vm._v(
          "\n\t\t" + _vm._s(_vm.$t("views.heicConversion.mainHeader")) + "\n\t"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subHeader" }, [
        _vm._v(
          "\n\t\t" +
            _vm._s(
              _vm.$t("views.heicConversion.subHeader", {
                count: _vm.submittedCount,
              })
            ) +
            "\n\t"
        ),
      ]),
      _vm._v(" "),
      _c("SpinnerComponent", { attrs: { size: 64 } }),
      _vm._v(" "),
      _c("ProgressBar", {
        attrs: {
          "progress-percentage": _vm.progressPercentage,
          text: _vm.$t("views.heicConversion.convertingPhotos", {
            count: _vm.submittedCount,
          }),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }